import { selectAppConfig } from "./selectAppConfig";
import {SwitchType} from "../../../helpers/constants";

export const selectProcessKasko = state => selectAppConfig(state).process_kasko || SwitchType.OFF;
